import React, { useRef, useState, useEffect } from "react"
import { useTranslation } from 'react-i18next';


import { useHookStore } from "../../../hook-store/store"
// import { resizeImageFile } from '../../utils/image/image-utils';
import { marks } from '../../../utils/marks';

import "./DiffusionOptionsDesc.css";

import EtaImage1 from "../../../image/for-iopaint/option-description/eta/et0.2-h100.jpg";
import EtaImage2 from "../../../image/for-iopaint/option-description/eta/et0.8-h100.jpg";
import EtaImage3 from "../../../image/for-iopaint/option-description/eta/et1-h100.jpg";

function DiffusionOptionsDescEta() {
    
    const [t] = useTranslation('translation');
  
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [hStore, hDispatch] = useHookStore();
    const { 
      // inputEta
    } = hStore.iopaintStore;

    return (
      <div className="diffsionOptionDesc">
        <div className="diffsionOptionDescRow">
          {t('diffusionOptions30', 'This input control image blurness of output image.')}
          <br/>
          {t('diffusionOptions31', 'When lower input value is used, clear and high contrast images are generated.')}
          {' '}{t('diffusionOptions32', 'When higher input values used, blur and less contrast images are generated.')}
          <br/>
          {t('diffusionOptions33', 'Default value 0.8 will generate balanced images.')}
          <br/>
          {t('diffusionOptions34', 'This is useful to adjust or control image output, when other inputs are same.')}
        </div>
        <div className="diffsionOptionDescRow">
          <div className="diffsionOptionDescImages">
            <div>
              <img className="diffsionOptionDescImage"
                src={EtaImage1}
              />
              0.2
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={EtaImage2}
              />
              0.8
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={EtaImage3}
              />
              1.0
            </div>
          </div>
        </div>
      </div>
    )
  }


export default DiffusionOptionsDescEta